import { render, staticRenderFns } from "./interest-calculation-create.vue?vue&type=template&id=bff3f3a0&scoped=true"
import script from "./interest-calculation-create.vue?vue&type=script&lang=js"
export * from "./interest-calculation-create.vue?vue&type=script&lang=js"
import style0 from "./interest-calculation-create.vue?vue&type=style&index=0&id=bff3f3a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff3f3a0",
  null
  
)

export default component.exports